"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.finleyBufferToCsvArray = exports.defaultParseConfig = void 0;
const Papa = __importStar(require("papaparse"));
const utils_1 = require("../utils");
const stripCarriageReturn = (str) => str.charAt(str.length - 1) === '\r' ? str.slice(0, str.length - 1) : str;
const defaultNewLine = '\n';
// Configuration options that are not meant to be overridden by external callers
exports.defaultParseConfig = {
    // Papaparse's automatic line-ending detection does not robustly handle files that use line
    // endings inconsistently. We force it to treat \n as the newline character. This may leave an
    // extra \r in the last column of every line, which we then need to strip out.
    newline: defaultNewLine,
    header: false,
    transform: stripCarriageReturn,
    transformHeader: stripCarriageReturn,
    quoteChar: '"',
    escapeChar: '"',
    skipEmptyLines: true,
};
/**
 * Assumptions:
 * 1) Papa parse does not handle header parsing consistently. Always handle it ourselves.
 * 2) Header option will always be set to true in our system even though it is false by default for Papa Parse. Finley usage is expected to be a formatted CSV object (string[] output can be implemented separately), but not necessarily with expectation of being sanitized.
 * 3) Dynamic typing is not required by default and is handled by our sanitizer logic rather than Papa parse configuration
 * 4) Specific character sets can be removed if specified through the regex option. This may need to be a general default but isolated for use in only some cases at the moment.
 */
const finleyBufferToCsvArray = async ({ buffer, delimiter = ',', dynamicTyping = false, headerRenameFunction, 
// This is a really bad workaround, but:
// - We have quite a bit of code that should eventually become backend-only that for now is also
//   used in the frontend (notably, in calc agent qa)
// - At the same time, the backend needs to use the papaparse stream API to handle large files.
//
// Possible fixes here:
// - Upgrade node to a version that supports standard html5 streams. Use in backend and frontend.
// - Or, make these usages backend-only.
useBackendLargeFileOptimizations = utils_1.EnvUtils.isBackend(), }) => {
    // ----- CSV PARSING -----
    const output = {
        originalHeaders: [],
        csvArray: [],
        errors: [], // Currently unused, and also not reliable (see usage below).
    };
    // Override default parser configurations
    const parseConfig = {
        ...exports.defaultParseConfig,
        delimiter,
        dynamicTyping,
    };
    let headerRow;
    const rowHandler = (row) => {
        if (!headerRow) {
            headerRow = headerRenameFunction
                ? row.map(headerRenameFunction)
                : [...row];
            output.originalHeaders = headerRow;
            return;
        }
        const convertedRow = {};
        headerRow.forEach((header, columnIdx) => {
            convertedRow[header] = row[columnIdx];
        });
        output.csvArray.push(convertedRow);
    };
    const errorHandler = (error) => output.errors.push(error);
    if (useBackendLargeFileOptimizations) {
        // eslint-disable-next-line global-require
        const stream = require('stream');
        // eslint-disable-next-line global-require
        const util = require('util');
        const streamFinished = util.promisify(stream.finished);
        let readIndex = 0;
        const readable = new stream.Readable({
            read(size) {
                if (readIndex === 0) {
                    // Strip UTF-8 byte order mark, if one is present. We can't use TextDecoder here because
                    // it doesn't support streaming. If we upgrade Node, we can consider switching to
                    // TextDecoderStream.
                    const BOM = [0xef, 0xbb, 0xbf];
                    if (buffer[0] === BOM[0] &&
                        buffer[1] === BOM[1] &&
                        buffer[2] === BOM[2]) {
                        readIndex += 3;
                    }
                }
                const newReadIndex = readIndex + size;
                const chunk = buffer.subarray(readIndex, newReadIndex);
                if (chunk.length > 0) {
                    this.push(chunk);
                    readIndex = newReadIndex;
                }
                else {
                    this.push(null);
                }
            },
        });
        const parserStream = Papa.parse(Papa.NODE_STREAM_INPUT, parseConfig);
        parserStream.on('data', rowHandler);
        parserStream.on('error', errorHandler); // Note: in NODE_STREAM_INPUT mode, papaparse doesn't support error reporting yet. So this does nothing.
        readable.pipe(parserStream);
        await streamFinished(parserStream);
    }
    else {
        const decoder = new TextDecoder('utf-8');
        const csvString = decoder.decode(buffer);
        Papa.parse(csvString, {
            ...parseConfig,
            step: (results) => {
                rowHandler(results.data);
                results.errors.forEach(errorHandler);
            },
        });
    }
    return output;
};
exports.finleyBufferToCsvArray = finleyBufferToCsvArray;
//# sourceMappingURL=buffer.js.map